<template>
  <div style="
      display: flex;
      justify-content: center;
      height: 80vh;
      align-items: center;
    ">
    <!-- <van-loading style="" size="24px" vertical>请稍后...</van-loading> -->
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
    <!-- <van-dialog
      v-model="IsShow"
      showCancelButton
      confirmButtonText="确定"
      cancelButtonText="取消"
      confirm-button-color="#ee0a24"
      @confirm="onSubmit(password)"
    >
      <div class="passWordField">
        <van-field
          label-width="20vw"
          v-model="password"
          placeholder="请输入密码"
          clearable
          label="密码"
          :value="password"
        ></van-field>
      </div>
    </van-dialog> -->
  </div>
</template>
<script>
import { Loading, Notify, Dialog, Toast, Field, Overlay } from "vant";
import service from "../../api/redirect/index";
import { mapActions, mapGetters } from "vuex";
import loading from "../../components/loading/loading";
import page from "../../api/page";
export default {
  components: {
    [Loading.name]: Loading,
    [Notify.name]: Notify,
    [Dialog.Component.name]: Dialog.Component,
    [Toast.name]: Toast,
    [Field.name]: Field,
    [Overlay.name]: Overlay,
    loading,
  },
  data () {
    return {
      password: "", //测试
      IsShow: true,
      isLoading: true, //loading状态
      obj: {}, // 分享进入的参数
      data: {}, //参数
      urlParmams: {}, // 调取记录参数
      goodsId: "", //商品id
    };
  },
  computed: {
    ...mapGetters(["activityPic"]),
  },
  methods: {
    ...mapActions([
      "wxLogin",
      "updateUserCartQuantity",
      "statusOut",
      "buyAgentStatus",
      "PageLogin"
    ]),
    getLoginMess () {
      let code = this.$route.query.code;
      let state = this.$route.query.state;
      console.log(state, 68);
      if (code == undefined || state == undefined) {
        Notify({ type: "danger", message: "没有授权信息" });
      } else {
        // let state = 'login?goodsId=111111111111191?shareUserId=3991245047935795200?SharedType=1'
        // lhy 截取参数
        let paramsArr = state.split("?");
        for (let i = 0, len = paramsArr.length; i < len; i++) {
          let arr = paramsArr[i].split("=");
          this.obj[arr[0]] = arr[1];
        }
        console.log(this.obj);
        if (this.obj.SharedType != undefined) {
          console.log("分享进入");
          // SharedType 等于1代表是在线商城获取跳转进入，SharedType 等于2代表积分商城进入
          if (this.obj.SharedType == 1) {
            console.log("在线商城进入");
            this.data = {
              code: code,
              isShared: true,
              sharedType: this.obj.SharedType,
              goodsId: this.obj.goodsId,
            };
          } else if (this.obj.SharedType == 2) {
            console.log("积分商城进入");
            this.data = {
              code: code,
              isShared: true,
              sharedType: this.obj.SharedType,
              goodsId: this.obj.goodsId,
              raffleId: this.obj.raffleId,
            };
          }
          console.log(this.data, "data参数");
          // service.isDebugger().then((resc) => {
          // if (resc.data == true) {
          //   // 跳转登录页面并且显示 确定后的弹窗
          //   // this.IsLoginShow = true;
          //   // console.log(resc.data, '扫码后调取的debugger接口true');
          //   this.$router.replace({ name: "login" });
          // } else {
          // this.postRecord(data)

          service.wxLoginRedirect(this.data).then((res) => {
            this.isLoading = false;
            if (res.data.identityStatus == "frozen") {
              this.$router.replace("frozen");
              return;
            }
            if (res.data.cartGoodsNum >= 0) {
              this.updateUserCartQuantity(res.data.cartGoodsNum);
            }
            // 代买状态
            this.buyAgentStatus({ show: false });
            // 移除银行状态
            // console.log(this.statusOut(),'this.statusOut')
            // this.statusOut();
            // win 如果是绑定用户（新人首单大礼包）
            // if (
            //   res.data.identityType == "common" &&
            //   res.data.identityStatus == "normal"
            // ) {
            //   // win 新人大礼包 获取首页活动详情
            //   service.packageDetail().then((r) => {
            //     // 如果有返回值存起来
            //     if (r.data !== "" && r.data) {
            //       console.log('进门来了')
            //       let userAll1 = r.data
            //       userAll1.isShowPageActivity = true
            //       this.PageLogin(userAll1).then(() => {
            //       });
            //     }
            //   })
            // } else {
            //   let showPage = {
            //     isShowPageActivity: false
            //   }
            //   this.PageLogin(showPage).then(() => {
            //   });
            // }

            this.wxLogin(res.data).then(() => {
              console.log(state);
              console.log(res.data, "调取接口后跳转前");
              if (res.data.isShared === true && res.data.goodsId !== "") {
                console.log("调取接口后跳转");
                //调取个后端需要的接口 后端需要记录
                if (res.data.sharedType == 1) {
                  this.urlParmams = {
                    code: code,
                    shareUserId: this.obj.shareUserId,
                    shareGoodsId: res.data.goodsId,
                    type: res.data.sharedType,
                  };
                } else if (res.data.sharedType == 2) {
                  this.urlParmams = {
                    code: code,
                    shareUserId: this.obj.shareUserId,
                    shareGoodsId: res.data.goodsId,
                    type: res.data.sharedType,
                    raffleId: res.data.raffleId,
                  };
                }
                console.log(this.urlParmams, "记录参数");
                this.goodsId = res.data.goodsId;
                this.postRecord(this.urlParmams);
                // this.isCheckDebugger(this.urlParmams)
                //跳转商品详情页

                // this.$router.push({ name: "goods", query: { code: res.data.goodsId, type: '1' } });
              } else {
                console.log("不是分享状态或者没有商品id");
              }
              // if (state == "/checkout") {
              //   this.$router.replace({
              //     path: page
              //   });
              // } else {
              //   console.log(state, "login");
              //   this.$router.replace({
              //     path: state
              //   });
              // }
              // =========================
            });
          });
          // }
          // });
        } else {
          let data = {
            code: code,
          };
          // service.isDebugger().then((resp) => {
          // if (resp.data == true) {
          //   this.$router.replace({ name: "login" });
          // } else {
          service.wxLoginRedirect(data).then((res) => {
            this.isLoading = false;
            if (res.data.identityStatus == "frozen") {
              this.$router.replace("frozen");
              return;
            }
            if (res.data.cartGoodsNum >= 0) {
              this.updateUserCartQuantity(res.data.cartGoodsNum);
            }
            // 代买状态
            this.buyAgentStatus({ show: false });
            // 移除银行状态
            // console.log(this.statusOut(),'this.statusOut')
            // this.statusOut();
            // win 如果是绑定用户（新人首单大礼包）
            // if (
            //   res.data.identityType == "common" &&
            //   res.data.identityStatus == "normal"
            // ) {
            //   // 获取首页活动详情
            //   service.packageDetail().then((r) => {
            //     console.log(r, r.data !== "" && r.data, r.data, 'redirect')
            //     // 如果有返回值存起来
            //     if (r.data !== "" && r.data) {
            //       console.log('进来了111')
            //       let userAll = r.data
            //       userAll.isShowPageActivity = true
            //       this.PageLogin(userAll).then(() => {
            //       });
            //     }
            //   })
            // } else {
            //   let showPage = {
            //     isShowPageActivity: false
            //   }
            //   this.PageLogin(showPage).then(() => {
            //   });
            // }
            this.wxLogin(res.data).then(() => {
              console.log(state);

              // win修改如果是散户跳转到绑定页面
              if (
                res.data.identityType == "common" &&
                res.data.identityStatus == "limited"
              ) {
                service.LoginUserIsBind(res.data.openId).then((res) => {
                  // 如果返回true跳转绑定页面
                  if (res.data !== "" && res.data) {
                    // lhy 修改 data长度等于14代表是扫绑定用户码进入  data长度小于14 代编是扫店长进入
                    console.log(res.data, 'res.data');
                    if (res.data.length === 14) {
                      this.$router.replace({
                        name: "bind",
                        query: { shareCode: res.data, shareType: true },
                      });
                    }
                    if (res.data.length < 14) {
                      this.$router.replace({
                        name: "bind",
                        query: { shareCode: res.data },
                      });
                    }

                  } else {
                    this.getURl();
                  }
                });
              } else {
                this.getURl();
              }
              // ==========原有代码========
              // if (state == "/checkout") {
              //   this.$router.replace({
              //     path: page
              //   });
              // } else {
              //   console.log(state, "login");
              //   this.$router.replace({
              //     path: state
              //   });
              // }
            });
          });
          // }
          // });
        }
      }
    },
    // win 判断跳转到
    getURl () {
      if (this.$route.query.state == "/checkout") {
        this.$router.replace({
          path: page,
        });
      } else {
        console.log(this.$route.query.state, "login");
        this.$router.replace({
          path: this.$route.query.state,
        });
      }
    },

    //lhy 扫码记录接口 scanRecord
    // postRecord (data) {
    //   service.scanRecord(data).then((res) => {
    //     console.log(res, 'record');
    //   });
    // },
    // isCheckDebugger (data) {
    //   console.log('扫码后调取的debugger接口');
    //   service.isDebugger().then((res) => {

    //     // debugger
    //     // false直接访问 true密码验证
    //     if (res.data == true) {
    //       // 跳转登录页面并且显示 确定后的弹窗
    //       // this.IsLoginShow = true;
    //       console.log(res.data, '扫码后调取的debugger接口true');
    //       this.$router.replace({ name: "login" });
    //     } else {
    //       console.log(res.data, '扫码后调取的debugger接口false');
    //       this.postRecord(data)
    //     }
    //   });
    // },
    //lhy 扫码记录接口 scanRecord
    postRecord (data) {
      // debugger
      console.log(data);
      service.scanRecord(data).then((res) => {
        if (res.data.status == true) {
          console.log(res.data.status, "记录页面接口为true跳转登录页面");
          // 跳转用户绑定页面
          this.$router.replace({
            name: "bind",
            query: { shareCode: res.data.shareCode },
          });
        } else {
          console.log(res.data.status, "记录页面接口为true跳转详情页面");
          //跳转商品详情页
          this.$router.replace({
            name: "goods",
            query: { code: this.goodsId, type: "1" },
          });
        }
      });
    },
  },
  mounted () {
    this.getLoginMess();
  },
};
</script>
